/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./frens.vue?vue&type=template&id=0a4b905b&scoped=true"
import script from "./frens.vue?vue&type=script&lang=js"
export * from "./frens.vue?vue&type=script&lang=js"
import style0 from "./frens.vue?vue&type=style&index=0&id=0a4b905b&prod&lang=scss"
import style1 from "./frens.vue?vue&type=style&index=1&id=0a4b905b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b905b",
  null
  
)

export default component.exports